/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraFoundationAdapterQuery,
  GamoraFoundationAdapterQueryArgs,
  GamoraFoundationAdapterQueryOperator,
} from '../query.js';
import { GamoraUUIDGuard } from '../../../guards/uuid.js';

/**
 * @public
 */
export type GamoraFoundationAdapterQueryGetOperand = [string, GamoraUUIDGuard];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryGetDefaultResult = unknown;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryGetArgs =
  GamoraFoundationAdapterQueryArgs<GamoraFoundationAdapterQueryGetOperand>;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryGetExtractResult<TQueryGet> =
  TQueryGet extends GamoraFoundationAdapterQueryGet<infer X> ? X : never;

/**
 * @public
 */
export class GamoraFoundationAdapterQueryGet<
  TResult = GamoraFoundationAdapterQueryGetDefaultResult,
> extends GamoraFoundationAdapterQuery<
  GamoraFoundationAdapterQueryGetOperand,
  TResult
> {
  protected override _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.GET;
  constructor(args: GamoraFoundationAdapterQueryGetArgs) {
    super(args);
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static override fromOperand<
    TResult = GamoraFoundationAdapterQueryGetDefaultResult,
  >(
    operand: GamoraFoundationAdapterQueryGetOperand,
    options?: any,
  ): GamoraFoundationAdapterQueryGet<TResult> {
    return new GamoraFoundationAdapterQueryGet({
      operand,
      options,
    });
  }
}
